import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@curves/ui-base';

import { isNumber } from '@Util/utils';
import InfoCard from './InfoCard';
/**
 * 商品卡片元件，顯示商品圖片、名稱、規格、價格、庫存等資訊
 * @component
 * @param {{
 *   className?: string;
 *   productName: string;
 *   variantName?: string;
 *   sku?: string;
 *   stock?: number;
 *   isLimited?: boolean;
 *   price?: number;
 *   desc?: string;
 *   onClick?: () => void;
 * }} props
 */
const ProductCard = (props) => {
    const {
        className,
        productName,
        sku,
        stock,
        isLimited = false,
        price,
        desc,
        onClick,
    } = props;
    const isSoldOut = isLimited && isNumber(stock) && stock < 1;
    const showStock = isLimited && isNumber(stock);
    return (
        <InfoCard className={clsx('product-card', className, { 'is-sold-out': isSoldOut })} onClick={onClick}>
            <Box className="product-card-content">
                <Typography className="product-card-title" variant="h6">
                    {productName}
                </Typography>
                {sku && <Typography className="product-card-sku">SKU：{sku}</Typography>}
                {price && <Typography className="product-card-price">{price}</Typography>}
                {desc && <Typography className="product-card-desc">{desc}</Typography>}
                {showStock && (
                    <Typography className="product-card-stock">
                        {isSoldOut ? '售完' : `庫存：${stock}`}
                    </Typography>
                )}
            </Box>
        </InfoCard>
    );
};
export default ProductCard;
